module.exports = __webpack_public_path__ + "img/ebcZh.2c8c8cab.svg";